import { Link } from 'react-router-dom';
import { useEffect } from 'react';

const sections = [
  {
    title: '2. Information We Collect',
    content: `We may collect the following categories of information:<br/>a. Personal Information<br/>Name<br/>Email address<br/>Phone number (if provided)<br/>Any information you submit via forms or communications<br/>b. Technical and Usage Data<br/>IP address<br/>Browser type and version<br/>Device type and operating system<br/>Pages visited and interaction data<br/>Date and time of access<br/>c. Communication Data<br/>Messages sent through contact forms or email<br/>Support requests and related correspondence<br/>d. Cookies and Tracking Technologies<br/>We use cookies and similar technologies to improve functionality and user experience. See Section 9 for details.`,
  },
  {
    title: '3. How We Use Your Information',
    content: `We use your data for the following purposes:<br/>a. Providing Services<br/>Responding to inquiries and requests<br/>Operating and maintaining the Site<br/>Delivering requested information or services<br/>b. Improving the Site<br/>Analyzing usage and performance<br/>Enhancing functionality and user experience<br/>c. Communication<br/>Sending responses, updates, or important notices<br/>Providing support<br/>d. Legal Compliance<br/>Complying with legal obligations<br/>Preventing fraud or misuse<br/>Enforcing our Terms of Use<br/>e. Marketing (if applicable)<br/>Sending updates or promotional content (only with your consent)<br/>You may opt out at any time`,
  },
  {
    title: '4. Legal Basis for Processing',
    content: `We process personal data based on:<br/>Consent — where you have provided it<br/>Legitimate Interests — to operate and improve our services<br/>Legal Obligations — where required by law<br/>Contractual Necessity — where processing is required to respond to your request`,
  },
  {
    title: '5. Sharing of Information',
    content: `We may share your data with:<br/>a. Service Providers<br/>Third-party providers who assist with:<br/>Website hosting<br/>Email communication<br/>Analytics<br/>These providers are required to protect your data and use it only for specified purposes.<br/>b. Legal Requirements<br/>We may disclose information if required by law or to protect rights, safety, or property.<br/>c. Business Transfers<br/>In the event of a merger or sale, data may be transferred to a new entity under similar protections.<br/>d. With Your Consent<br/>We may share data where you explicitly agree.<br/>We do not sell personal data.`,
  },
  {
    title: '6. Data Retention',
    content: `We retain personal data only as long as necessary to:<br/>Fulfill the purposes described in this Policy<br/>Comply with legal obligations<br/>Resolve disputes<br/>Retention periods vary depending on the type of data.`,
  },
  {
    title: '7. Data Security',
    content: `We implement appropriate technical and organizational measures, including:<br/>Secure data storage and transmission<br/>Access controls<br/>Monitoring and protection against unauthorized access<br/>However, no system is completely secure, and we cannot guarantee absolute security.`,
  },
  {
    title: '8. Your Rights',
    content: `Under applicable data protection laws, you have the right to:<br/>Access your personal data<br/>Correct inaccurate data<br/>Request deletion of your data<br/>Restrict processing in certain cases<br/>Object to processing<br/>Request data portability<br/>To exercise your rights, contact:<br/>support@regent-digital.com`,
  },
  {
    title: '9. Cookies',
    content: `We use cookies to improve functionality and user experience.<br/>Types of cookies we use:<br/>Essential – required for operation of the Site<br/>Analytics – help us understand usage<br/>Functional – remember preferences<br/>You can manage or disable cookies through your browser settings.`,
  },
  {
    title: '10. International Data Transfers',
    content: `Your data may be processed outside your country of residence.<br/>Where required, we ensure appropriate safeguards are in place in accordance with applicable laws.`,
  },
  {
    title: '11. Children\'s Privacy',
    content: `The Site is not intended for individuals under the age of 16.<br/>We do not knowingly collect personal data from children. If we become aware of such data, we will delete it.`,
  },
  {
    title: '12. Changes to this Privacy Policy',
    content: `We may update this Privacy Policy from time to time.<br/>Updates will be posted on this page with a revised effective date. Continued use of the Site constitutes acceptance of the updated Policy.`,
  },
  {
    title: '13. Contact Information',
    content: `Regent Digital LTD<br/>International House<br/>55 Longsmith Street<br/>Gloucester<br/>GL1 2HT<br/>United Kingdom<br/>Email: support@regent-digital.com<br/>Phone: +447520657571`,
  },
];

export default function PrivacyPolicy() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <div className="min-h-screen bg-[#0F0F0F]">
      {/* Navbar */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-[#1A1A1A] border-b border-white/10">
        <div className="px-8 md:px-16 py-4 flex items-center justify-between">
          <Link to="/" className="cursor-pointer flex items-center gap-3">
            <div className="relative w-10 h-10 flex items-center justify-center flex-shrink-0">
              <div className="absolute inset-0 bg-[#FFD93D] rounded-xl rotate-3" />
              <div className="absolute inset-0 bg-black rounded-xl -rotate-1" />
              <span
                className="relative z-10 font-black text-[#FFD93D]"
                style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: '18px', letterSpacing: '-0.05em' }}
              >RD</span>
            </div>
            <div className="flex flex-col leading-none">
              <span
                className="text-white font-black uppercase"
                style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: '22px', letterSpacing: '0.08em' }}
              >REGENT</span>
              <span
                className="text-[#FFD93D] font-black uppercase"
                style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: '22px', letterSpacing: '0.08em' }}
              >DIGITAL</span>
            </div>
          </Link>

          <Link
            to="/"
            className="flex items-center gap-2 text-white/60 hover:text-[#FFD93D] transition-colors font-semibold text-sm cursor-pointer whitespace-nowrap"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-left-line" />
            </div>
            Back to Home
          </Link>
        </div>
      </nav>

      {/* Hero */}
      <div className="pt-32 pb-16 px-8 md:px-16 border-b border-white/10">
        <div className="max-w-4xl">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-1.5 h-8 bg-[#FFD93D] rounded-full" />
            <span
              className="text-[#FFD93D] font-black uppercase tracking-widest text-sm"
              style={{ fontFamily: "'Bebas Neue', sans-serif", letterSpacing: '0.2em' }}
            >Legal</span>
          </div>
          <h1
            className="text-white font-black uppercase mb-4"
            style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: 'clamp(48px, 7vw, 96px)', lineHeight: 0.9, letterSpacing: '-0.02em' }}
          >
            Privacy Policy
          </h1>
          <p className="text-white/40 font-semibold text-sm mt-6">
            Last Updated: April 22, 2026
          </p>
        </div>
      </div>

      {/* Content */}
      <div className="px-8 md:px-16 py-16">
        <div className="max-w-4xl">
          {/* Intro */}
          <p className="text-white/60 font-semibold text-base leading-relaxed mb-12 border-l-2 border-[#FFD93D] pl-6" dangerouslySetInnerHTML={{__html: `This Privacy Policy explains how Regent Digital LTD ("Company", "we", "our", or "us") collects, uses, stores, and protects personal data when you use this website (the "Site") and any related services (collectively, the "Services").<br/><br/>Registered Office:<br/>Regent Digital LTD<br/>International House<br/>55 Longsmith Street<br/>Gloucester<br/>GL1 2HT<br/>United Kingdom<br/><br/>Contact Information:<br/>Email: support@regent-digital.com<br/>Phone: +447520657571<br/><br/>We are committed to protecting your privacy and handling your personal data in accordance with applicable data protection laws, including the UK GDPR.<br/><br/>By using the Site, you acknowledge that you have read and understood this Privacy Policy.`}} />

          {/* Sections */}
          <div className="space-y-10">
            {sections.map((section, index) => (
              <div
                key={index}
                className="group border border-white/10 rounded-xl p-8 hover:border-[#FFD93D]/30 transition-colors bg-[#1A1A1A]/50"
              >
                <h2
                  className="text-white font-black uppercase mb-4"
                  style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: '22px', letterSpacing: '0.05em' }}
                >
                  {section.title}
                </h2>
                <p className="text-white/55 font-semibold text-sm leading-relaxed" dangerouslySetInnerHTML={{__html: section.content}} />
              </div>
            ))}
          </div>

          {/* CTA */}
          <div className="mt-16 border-t border-white/10 pt-12 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
            <div>
              <p className="text-white/70 font-semibold text-base mb-1">
                Questions about your privacy?
              </p>
              <p className="text-white/40 font-semibold text-sm">
                We&apos;re happy to clarify how we handle your data.
              </p>
            </div>
            <a
              href="mailto:support@regent-digital.com"
              className="bg-[#FFD93D] text-black font-black uppercase px-8 py-3 rounded-full hover:bg-[#FF8C42] hover:text-white transition-colors cursor-pointer whitespace-nowrap inline-flex items-center gap-2"
              style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: '16px' }}
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-mail-line" />
              </div>
              Contact Us
            </a>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-[#1A1A1A] py-8 px-8 md:px-16 border-t border-white/10 mt-8">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/40 font-semibold text-sm">
            © 2026 Regent Digital LTD. All rights reserved. Registered in England &amp; Wales.
          </p>
          <Link
            to="/"
            className="text-white/40 hover:text-[#FFD93D] font-semibold text-sm transition-colors cursor-pointer whitespace-nowrap"
          >
            ← Back to Homepage
          </Link>
        </div>
      </footer>
    </div>
  );
}
